// ============================================================
// TMR Portal Admin — linhas de contato (rótulo + valor + ações)
// Compartilhado pelos modais de peek de Pessoa e de Usuário.
// ============================================================
import { useState } from 'react';
import { Icons, StrokeIcon } from '../lib/icons';
import { waHref } from '../lib/format';

/** One contact line: a labelled value plus its copy/WhatsApp actions. */
export interface ContactRow {
  key: string;
  label: string;
  value?: string;
  /** `phone` also offers a WhatsApp shortcut when the number has a usable shape. */
  kind?: 'phone' | 'text';
}

export function ContactRows({ rows }: { rows: ContactRow[] }) {
  const [copied, setCopied] = useState('');
  const copy = (key: string, value?: string) => {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(''), 1500);
    });
  };

  return (
    <div style={{ padding: '6px 16px 8px' }}>
      {rows.map((r) => {
        const wa = r.kind === 'phone' ? waHref(r.value) : null;
        return (
          <div key={r.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '12px 8px', borderBottom: '1px solid var(--border-default)' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 11, color: 'var(--fg-subtle)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{r.label}</div>
              <div style={{ fontSize: 14, color: r.value ? 'var(--ink-900)' : 'var(--stone-400)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.value || '—'}</div>
            </div>
            {r.value && (
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                {wa && (
                  <a
                    href={wa}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pa-icon-btn"
                    style={{ width: 32, height: 32, color: 'var(--forest-700)', textDecoration: 'none' }}
                    title="Abrir no WhatsApp"
                  >
                    <StrokeIcon d={Icons.whatsapp} size={15} />
                  </a>
                )}
                <button type="button" onClick={() => copy(r.key, r.value)} className="pa-icon-btn" style={{ width: 32, height: 32 }} title="Copiar">
                  <StrokeIcon d={copied === r.key ? Icons.check : Icons.copy} size={14} />
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
